import script from "./InvitationList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationList.vue?vue&type=script&setup=true&lang=js"

import "./InvitationList.vue?vue&type=style&index=0&id=3c3eb32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3eb32e"]])

export default __exports__